module.exports = __webpack_public_path__ + "media/greenhouse-fullhd05.d03e0bac.mp4";